import { formatNumberWithTwoDecimals } from './Shared/Utils';
import { DEFAULT_HEADER } from './Config/userToken';
import userAuth from './Config/userauth';
import moment from "moment";
import { APIS } from './Config/apis';

export function fillCombo(dropDownListId, url, self, emptyItem, useToken = false) {
    fetch(url, {
        method: 'GET',
        headers: useToken ? DEFAULT_HEADER.get() : { 'Content-Type': 'application/json' },
    })
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (emptyItem && data.length > 0) {
                data.unshift(emptyItem);
            }
        });
}

export function getTableColumns(columns) {
    let columnsDefinition = Object.getOwnPropertyNames(columns);
    let searchTableColumns = [];
    columnsDefinition.forEach((item, index) => {
        let column = {
            index: index,
            name: item,
            title: columns[item].title ?? "",
            field: columns[item].field ?? "",
            format: columns[item].format ?? 0,
            summarize: columns[item].summarize ?? false,
            summarizeCustom: columns[item].summarizeCustom ?? false,
            show: columns[item].show ?? true,
            Header: () => (
                <span title={columns[item].tooltip ?? columns[item].title}>
                    {columns[item].title}
                </span>
            ),
            accessor: item,
            sortable: columns[item]?.sortable,
            filterable: columns[item]?.filterable ?? true,
            resizable: true,
            Footer: columnProps => (
                <span><b>
                    {columns[item].summarizeCustom
                        ? renderCustomSummary(columnProps.data, columns[item].summarizeCustom)
                        : ""}
                    {columnProps.data.length > 0 && columns[item].summarize
                        ? formatTableColumn(
                            sumPropertyValue(columnProps.data.map(v => v._original), item),
                            columns[item].signo
                        )
                        : ""}
                </b></span>
            ),

        };
        if (columns[item].displayFormat === 'date' || columns[item].displayFormat === 4) {
            column.id = item;
            column.accessor = row => row[item]
            column.Cell = ({ value }) =>
                value && moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : ""
            column.sortMethod = (a, b, desc) => {
                const dateA = moment(a);
                const dateB = moment(b);
                if (!dateA.isValid() || !dateB.isValid()) return 0;

                const result = dateA.diff(dateB);
                return desc ? -Math.sign(result) : Math.sign(result);
            };

        }
        if (columns[item].displayFormat === 'money' || columns[item].displayFormat === 5) {
            column.id = item;
            column.accessor = row => row[item];

            column.Cell = ({ value }) =>
                <div style={{ marginLeft: columns[item].alignRight ? "auto" : undefined }}>
                    {value != null && !isNaN(value) ? formatMoney(value) : "-"}
                </div>;
        }


        if (columns[item].width != null)
            column.width = columns[item].width;

        searchTableColumns.push(column);
    });

    return searchTableColumns;
}
function formatMoney(value, currency = "$") {
    return currency + ' ' + parseFloat(value).toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function renderCustomSummary(rows, summarizeCustom) {
    const parentOriginal = rows?.[0]?._original.__parentOriginal;
    return formatCustomLabel(parentOriginal, summarizeCustom, rows);
}

export function formatCustomLabel(parentOriginal, summarizeCustom, rows) {
    if (!parentOriginal || !summarizeCustom) return '';

    if (typeof summarizeCustom === 'function') {
        const val = summarizeCustom({ parentOriginal, rows });
        return isFiniteNumber(val) ? formatMoney(val) : '';
    }
    const raw = parentOriginal[summarizeCustom];
    const num = toNumber(raw);
    return num && isFiniteNumber(num) ? formatMoney(num) : '';
}

function toNumber(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    if (typeof v === 'string')
        return parseFloat(v.replace('$', '').replace(/\./g, '').replace(',', '.').trim());
    return Number(v) || 0;
}

function isFiniteNumber(n) {
    return typeof n === 'number' && isFinite(n);
}

export function sumPropertyValue(items, prop) {
    let total = items.reduce((sum, item) => {
        let value = item[prop];

        if (typeof value === 'string') {
            value = value.replace('$', '').replace(/\./g, '').replace(',', '.').trim();
        }

        value = parseFloat(value);

        return sum + (isNaN(value) ? 0 : value);
    }, 0);

    return total;
}



export function formatTableColumn(value, signo = '') {
    let label = `${signo} ${formatNumberWithTwoDecimals(value)}`;
    return label.trim();
}

export function codeDescriptionString(code, desc) {
    return codeString(code) + descriptionString(desc);
}
export function codeString(code) {
    return (code == null ? '' : "(" + code + ") ");
}
export function descriptionString(desc) {
    return (desc == null || desc === '' ? '(SIN DATOS)' : desc);
}

export function fetchDataGET(url, useToken = false) {
    return new Promise(function (resolve, reject) {
        fetch(url, {
            method: 'GET',
            headers: useToken ? DEFAULT_HEADER.get() : { 'Content-Type': 'application/json' },
        }).then((response) => {
            let value = authorizeAction(response);
            if (value) {
                resolve(value);
            }
        }).catch((error) => {
            reject(error);
        });
    });
}

export function fetchDataPOST(url, bodyData, useToken = false, contentType = 'application/json') {
    return new Promise(function (resolve, reject) {
        fetch(url, {
            method: 'POST',
            headers: useToken ? DEFAULT_HEADER.get() : { 'Content-Type': contentType },
            body: JSON.stringify(bodyData)
        }).then((response) => {
            let value = authorizeAction(response);
            if (value) {
                resolve(value);
            }
        }).catch((error) => {
            reject(error);
        });
    });
}

export function authorizeAction(response) {
    if (response.status === 204) return null;
    if (response.status === 401) {
        var userType = userAuth.isUserSimulator() || userAuth.isAdmin();
        userAuth.signout(() => { window.location.href = userType ? '/admin' : '/login'; });
        return;
    }
    return response.json();
}

export function getFirstDay(date = null) {
    if (!date)
        date = new Date();

    return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function getPeriodRange(dateInit, dateEnd, reverse = false) {
    let periodRange = [];

    let date1 = new Date(dateInit.getFullYear(), dateInit.getMonth(), 1, 0, 0, 0, 0);
    let date2 = new Date(dateEnd.getFullYear(), dateEnd.getMonth(), 1, 0, 0, 0, 0);

    while (date1 <= date2) {
        periodRange.push(getPeriod(date1));
        date1.setMonth(date1.getMonth() + 1);
    }

    return (reverse) ? periodRange.reverse() : periodRange;
}

export function getPeriod(date = null) {
    if (!date)
        date = new Date();

    var month = (date.getMonth() + 1);
    var year = (date.getFullYear() * 100);
    var period = year + month;

    return period;
}

export function getPeriodPart(period) {
    var month = (period % 100);
    var year = parseInt(period / 100);

    return [year, month];
}

export function getPeriodName(period) {
    const monthName = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    var month = (period % 100) - 1;
    var year = parseInt(period / 100);
    var periodName = monthName[month] + ', ' + year.toString();

    return periodName;
}

export function getLastDay(date = null) {
    if (!date)
        date = new Date();

    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export async function getParameters(key) {
    return await fetchDataGET(APIS.URLS.PARAMETERS_GET + '?key=' + key, true)
        .then((response) => {
            return response;
        })
        .catch((error) => { console.log(error); })
}

export function saveParameters(key, value) {
    fetchDataPOST(APIS.URLS.PARAMETERS_SAVE, { 'Key': key, 'Value': value }, true)
        .then((response) => {
            return response;
        })
        .catch((error) => { console.log(error); })
}